import RcSlider from 'rc-slider'
import React, { useState } from 'react'
import { SliderStyler } from 'components/misc/slider-styler'

export const ExperienceSlider: React.FC<{
  onChange: (experience: number) => void
  value?: number
}> = ({ onChange, value }) => {
  const [useValue, setUseValue] = useState(value || 0)
  return (
    <SliderStyler>
      <RcSlider
        min={0}
        max={10}
        value={useValue}
        onChange={(_v) => {
          const v = _v as number
          setUseValue(v)
          onChange(v)
        }}
      />
    </SliderStyler>
  )
}
